import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSection';
import TableSection from 'components/sales/tableSection/tableSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';

const EditMrf = ({
  match,
  getMrfDetailsByGate,
  mrfDetailsByGate,
  deleteMrfDetail,
  getMaterial,
  getMateriaById,
  updateMrfDetails,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const Headers = [
    'Category Id',
    'Category Name',
    'HSN Code',
    'Material Id',
    'Material Name',
    'Quantity',
    'Actions',
  ];
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selectData, setSelectData] = useState();
  const [data, setData] = useState();
  const [catId, setCatId] = useState('');
  const [materialData, setMaterialData] = useState([]);
  const [inventoryForm, setInventoryForm] = useState({
    id: '',
    category_id: '',
    material_id: '',
    quantity: '',
  });

  const handleModalHide = async () => {
    setIsModal(false);
    setIsLoading(true);
    await getMrfDetailsByGate(match.params.id, match.params.gateId);
    setIsLoading(false);
  };

  const handleProductData = async () => {
    if (inventoryForm) {
      const res = await updateMrfDetails(inventoryForm);
      if (res) {
        setSelectData([]);
        setIsModal(true);
      }
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getMrfDetailsByGate(match.params.id, match.params.gateId);
      setIsLoading(false);
    })();
  }, [getMrfDetailsByGate]);

  useEffect(() => {
    setData(mrfDetailsByGate?.mrf_details);
  }, [mrfDetailsByGate]);

  useEffect(() => {
    if (refresh === true)
      (async () => {
        setIsLoading(true);
        await getMrfDetailsByGate(match.params.id, match.params.gateId);
        setIsLoading(false);
      })();
  }, [refresh]);

  useEffect(() => {
    if (catId) {
      (async () => {
        setIsLoading(true);
        await getMateriaById(catId);
        setIsLoading(false);
      })();
    }
  }, [catId]);

  useEffect(() => {
    if (getMaterial) {
      setMaterialData(getMaterial);
    }
  }, [getMaterial]);

  const tableForm = (el) => {
    const data = el.map((element) =>
      Object.assign(
        {},
        ...[
          'id',
          'category_id',
          'category_name',
          'hsn_code',
          'material_id',
          'material_name',
          'quantity',
        ].map((key) => ({
          [key]: element[key],
        })),
        {
          Action: [
            { name: 'Edit', link: '' },
            { name: 'Delete', link: '' },
          ],
        }
      )
    );
    return (
      <TableSection
        data={data}
        headers={Headers}
        isId={false}
        deleteMrfDetail={deleteMrfDetail}
        refreshPage={(val) => {
          if (val === true) {
            setRefresh(true);
          }
        }}
        updateMrf={(val) => {
          setCatId(val && val[0].category_id);
          setSelectData(val);
          setInventoryForm({
            ...inventoryForm,
            id: val[0].id,
            category_id: val[0].category_id,
            material_id: val[0].material_id,
            quantity: val[0].quantity,
          });
        }}
        detailList={data && data}
      ></TableSection>
    );
  };

  return (
    <Layout
      title={localization.mrf}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/view-material-requisition/${match.params.id}/stage/${match.params.gateId}`}
    >
      <div>
        {data &&
          data.length > 0 &&
          data.map((obj, i) => {
            return (
              <FormSection title={`Gate No - ` + obj.gate_no} key={i}>
                {tableForm(obj && obj.materials)}
              </FormSection>
            );
          })}

        {selectData && selectData?.length > 0 && (
          <FormSection title={localization.productInventory}>
            <div className="w-100 row mx-0">
              <DropDownInput
                label={localization.selectCategory}
                data={mrfDetailsByGate && mrfDetailsByGate.categories}
                getIdValue={(val) => {
                  setInventoryForm({ ...inventoryForm, category_id: val.id });
                  setCatId(val.id);
                }}
                errorMsg={localization.isRequired}
                value={selectData && selectData[0].category_name}
                required
                isStarRequired={true}
              />
              {inventoryForm.category_id && (
                <DropDownInput
                  label={localization.selectMaterial}
                  data={materialData}
                  getIdValue={(val) => {
                    setInventoryForm({
                      ...inventoryForm,
                      material_id: val.id,
                    });
                  }}
                  errorMsg={localization.requiredselectMaterial}
                  value={selectData && selectData[0].material_name}
                  required
                  isStarRequired={true}
                />
              )}
              <ConstantInput
                label={localization.quantity}
                errorMsg={
                  inventoryForm.quantity
                    ? localization.numberError
                    : localization.isRequired
                }
                type="text"
                value={selectData && selectData[0].quantity.toString()}
                handleChange={(val) => {
                  setInventoryForm({ ...inventoryForm, quantity: val });
                }}
              />
              <ButtonWithIcon
                onClick={handleProductData}
                title={localization.submit}
              />
            </div>
          </FormSection>
        )}
      </div>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.updatedSuccessfully}</h5>
          <Button className="btn btn-primary mb-4" onClick={handleModalHide}>
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default EditMrf;
